import {ADMIN_LANG} from "../../settings";

type Props = {
    message?: string;
    title?: string;
    error_code?: string;
};
const ErrorPage = ({ error_code='404', title = ADMIN_LANG.not_found_title, message=ADMIN_LANG.not_found_description}: Props) => {
    return (
        <div className='d-flex flex-column justify-content-center align-items-center p-3' style={{'height': '100vh'}}>
            <h1>{error_code} - {title}</h1>
            <p>{message}</p>
        </div>
    );
};

export default ErrorPage;